import React from 'react';
import { Formik, FormikHelpers, Field, Form } from 'formik';
import * as Yup from 'yup';

import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

import { SubmitButton } from '../../../../../../components/Form';
import {
  AutocompletePlace,
  TextField,
} from '../../../../../../components/FormikAdapter';
import { FormActions, FormRow } from '../../../../../../components/FormLayout';
import { SingleMarkerMap } from '../../../../../../components/Map';

//------------------------------------------------------------------------------
// Styles
//------------------------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  map: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    height: '400px',
    width: '100%',
  },
}));

//------------------------------------------------------------------------------
// Types
//------------------------------------------------------------------------------

type Place = {
  lat: number;
  lng: number;
  address: string;
  neighborhood: string;
};

interface EditStoreFormValues {
  name: string;
  phone: string;
  place: Place | null;
}

type Props = {
  initialValues: EditStoreFormValues;
  onSubmit: (
    values: EditStoreFormValues,
    actions: FormikHelpers<EditStoreFormValues>
  ) => void;
  onDelete: () => void;
};

//------------------------------------------------------------------------------
// Validation
//------------------------------------------------------------------------------

const ValidationSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  place: Yup.mixed().required('Required'),
});

//------------------------------------------------------------------------------
// Form
//------------------------------------------------------------------------------

const EditStoreForm: React.FC<Props> = ({
  onDelete,
  onSubmit,
  initialValues,
}) => {
  const classes = useStyles();

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={ValidationSchema}
    >
      {({ isSubmitting, values: { place } }) => (
        <Form translate="no" noValidate>
          <FormRow>
            <Field
              component={TextField}
              name="name"
              label="Name"
              autoFocus
              fullWidth
              required
            />

            <Field component={TextField} name="phone" label="Phone" fullWidth />
          </FormRow>

          <FormRow>
            <Field
              component={AutocompletePlace}
              name="place"
              label="Address"
              TextFieldProps={{
                label: 'Address',
                required: true,
                placeholder: 'Search for an address',
                fullWidth: true,
              }}
            />
          </FormRow>

          <div className={classes.map}>
            <SingleMarkerMap
              marker={place ? { lat: place.lat, lng: place.lng } : undefined}
            />
          </div>

          <FormActions
            secondary={
              <Button variant="outlined" color="secondary" onClick={onDelete}>
                Delete
              </Button>
            }
          >
            <SubmitButton isSubmitting={isSubmitting}>
              Update Store
            </SubmitButton>
          </FormActions>
        </Form>
      )}
    </Formik>
  );
};

export default EditStoreForm;
